
            const data = {"name":"icon-heart-fill","data":{"width":"12","height":"12","viewBox":"0 0 32 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M8.6 2.1c2.7 0 4.9 1.1 6.6 3.2.6.8.9 1 1.6.1a8.4 8.4 0 0110.4-2.5 8.6 8.6 0 014.5 9.9c-.4 1.7-1.2 3.3-2.2 4.8-3.1 4.5-7.1 8-11.7 10.8-1.3.8-2.5.8-3.8 0A35 35 0 012 17.1a12 12 0 01-2.1-6.4 8.6 8.6 0 018.7-8.6z\"/>"}}
        
                module.exports = data
                